module.exports = __webpack_public_path__ + "img/vue1-toebox_bleu.f4754511.png";